module.exports = "/img/filter_kanban.1c0c87e8.gif";